<div class="work-interval">
  <div class="interval-item"
       [ngClass]="getClass(status.int_type)"
       *ngFor="let status of statuses" [ngStyle]="status.style"></div>
</div>
